// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2A6sd","clickArea":"styles__clickArea___194TU"};